module.exports = __webpack_public_path__ + "img/1.5719995e.jpg";